<template>
    <div class="swiper_container"  v-if="picData.length">
        <div v-if="picData?.length == 1" class="top_img" :class="$route.name == 'index' ? 'index_top_img' : ''">
            <img :src="pic.url" alt="" v-for="(pic , index) in picData" :key="index">
        </div>
        <div  v-else v-swiper:mySwiper="swiperOption" class="swiper indexSwiperOrigin_Banner" :class="$route.name == 'index' ? 'index_top_img' : ''">
            <div class="swiper-wrapper">
                <div v-for="(pic , index) in picData" :key="index" class="swiper-slide" @click="goUrl(pic.redirect_to)">
                    <img :src="pic.url" class="slide-img"/>
                </div>
            </div>
            <div class="swiper-pagination my_pagination"></div>
        </div>
    </div>
</template>

<script>
export default{
name: "MySwiper",
    data() {
        return {
            currentId: 1,
        }
    },
    methods:{
      goUrl(url){
        if(url){
        window.open(url)
      }
      }
    },
    props: {
      picData: {
        type: Array,
        default: () => {
          return [];
        },
      },
      swiperOption: {
        type: Object,
        default: () => {
          return {
            loop: true, // 是否循环播放
            speed: 400, // 切换速度 ms
            centeredSlides: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // navigation: {
            //   nextEl: ".swiper-button-next",
            //   prevEl: ".swiper-button-prev"
            // },
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
          };
        },
      },
  },
    
}
</script>

<style lang="stylus" scoped>
    .swiper_container {
        width: 100%;
      .index_top_img{
        height: 680px !important;
      }
      .top_img{
          width: 100%;
          height: 560px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      .swiper {
        width: 100%;
        height: 560px;
    
        .swiper-wrapper {
          .slide-img {
            width: 100%;
            height: 100%;
          }
        }
        .my_pagination {
      :deep(.swiper-pagination-bullet:focus ) {
        outline: none;
      }

      :deep(.swiper-pagination-bullet-active ) {
        opacity: 1;
        background-clip: content-box;
        background: rgba(255, 255, 255, 0.5);
      }

      :deep(.swiper-pagination-bullet-active:before ) {
        content: '';
        position: absolute;
        height: 4px;
        left: 0;
        top: 0;
        width: 0;
        opacity: 1;
        background: #ffffff;
        border-radius: 2px;
        background-clip: content-box;
        -webkit-animation: bannerProgress 3.3s ease-in-out;
        -moz-animation: bannerProgress 3.3s ease-in-out;
        -o-animation: bannerProgress 3.3s ease-in-out;
        -ms-animation: bannerProgress 3.3s ease-in-out;
        animation: bannerProgress 3.3s ease-in-out;
        z-index: 186;
        overflow: hidden;
      }

      :deep(.swiper-pagination-bullet ) {
        position: relative;
        margin: 20px 10px;
        border-radius: 2px;
        background: rgba(255, 255, 255, 0.5);
        opacity: 1;
        width: 50px;
        height: 4px;
        background-clip: content-box;
        z-index: 168;
        top: -3px;
      }
    }
  }
  @keyframes bannerProgress {
    100% {
      width: 50px;
    }
  }
}
</style>
   